export default "__VITE_ASSET__11905de5__"